import { Button, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { DeliveryStatusSearch } from "./DeliveryStatusSearch";

export const DeliveryStatus:React.FC<any>=React.memo((props)=>{
    const navigate = useNavigate()
    const [cartOpen, setCartOpen] = useState(false);

    const handleCartClick = () => {
        setCartOpen(true);
    };
    
    const handleCartClose = () => {
        setCartOpen(false);
    };

    const columns: IColumns[] = [
        {
            header: "Receipt#",
            fieldName: "workLocationName",
            tooltip: true,
        },
        {
            header: "Time",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Driver",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Guest Name",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Departure@",
            fieldName: "address",
            tooltip: true,
        },
        {
            header: "Driver went By",
            fieldName: "address",
            tooltip: true,
        },
       
    ];

    const handleClick = (path:string) =>{
        navigate(path)
       }
     
    return(
        <Grid container direction="column"  sx={{ minHeight: '100vh' }}>
            {/* Header Section */}
            <Grid item>
                <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px' }}>
                    {/* Title on the left */}
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: "green" }}>
                        Delivery Status
                    </Typography>
                    <Grid sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                       
                        <IconButton onClick={handleCartClick}>
                            <WSIcons.SearchIcon />
                        </IconButton>
                        <DeliveryStatusSearch open={cartOpen} onClose={handleCartClose} />
                        <IconButton>
                            <WSIcons.CloseIcon sx={{ backgroundColor: 'red', color: 'white' }} onClick={()=>handleClick('/')}/>
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>

            {/* DataGrid Section */}
            <Grid item sx={{ flex: 1 }}>
                <WSDataGrid
                    id="itemGrid"
                    title=""
                    columns={columns}
                />
            </Grid>

            {/* Footer Section */}
            <Grid
  item
  sx={{
    backgroundColor: "#333",
    padding: "1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  {/* Left-aligned items: icon and one button */}
  <Grid
    sx={{
      display: "flex",
      alignItems: "center",
      gap: "1rem", // space between icon and button
    }}
  >
    <WSIcons.GTranslateIcon sx={{ color: "white" }} />
    
  </Grid>

  {/* Right-aligned items: two buttons */}
  <Grid
    sx={{
      display: "flex",
      alignItems: "center",
      gap: "1rem", // space between the buttons
    }}
  >
    <Button
      variant="outlined"
      sx={{
        color: "white",
        borderColor: "green",
        "&:hover": {
          backgroundColor: "#2e7d32",
        },
      }}
    >
      Cash Settle
    </Button>
    <Button
      variant="contained"
      sx={{
        backgroundColor: "green",
        "&:hover": {
          backgroundColor: "#388e3c",
        },
      }}
    >
      Map
    </Button>
  </Grid>
</Grid>

        </Grid>
    )
})